// extracted by mini-css-extract-plugin
export var arrow = "UserRegisterModal-module--arrow--c866a";
export var arrowNo = "UserRegisterModal-module--arrow_no--747a3";
export var arrowYes = "UserRegisterModal-module--arrow_yes--3ba8e";
export var bottomLogoWrapper = "UserRegisterModal-module--bottomLogoWrapper--207e1";
export var bottomWrapper = "UserRegisterModal-module--bottomWrapper--1b2bf";
export var button = "UserRegisterModal-module--button--a88ce";
export var buttonContainer = "UserRegisterModal-module--buttonContainer--44095";
export var contentContainer = "UserRegisterModal-module--contentContainer--38a7a";
export var error = "UserRegisterModal-module--error--5a596";
export var flex = "UserRegisterModal-module--flex--52615";
export var flex1 = "UserRegisterModal-module--flex_1--4436a";
export var flexCenter = "UserRegisterModal-module--flex_center--57ac5";
export var flexCenterCol = "UserRegisterModal-module--flex_center_col--161e9";
export var flexCol = "UserRegisterModal-module--flex_col--89901";
export var flexFixCenterCol = "UserRegisterModal-module--flex_fix_center_col--18e79";
export var flexFixedCenterCol = "UserRegisterModal-module--flex_fixed_center_col--234b6";
export var inputContainer = "UserRegisterModal-module--inputContainer--894df";
export var inputIcon = "UserRegisterModal-module--inputIcon--531b2";
export var link = "UserRegisterModal-module--link--e32c1";
export var noIcon = "UserRegisterModal-module--noIcon--a769f";
export var providerLink = "UserRegisterModal-module--providerLink--7baa6";
export var providerText = "UserRegisterModal-module--providerText--4d7a7";
export var reCaptchaContainer = "UserRegisterModal-module--reCaptchaContainer--1e1c5";
export var reCaptchaIcon = "UserRegisterModal-module--reCaptchaIcon--9b1c0";
export var reCaptchaText = "UserRegisterModal-module--reCaptchaText--bab9d";
export var red = "UserRegisterModal-module--red--ac35f";
export var registerContainer = "UserRegisterModal-module--registerContainer--ea5ee";
export var registerText = "UserRegisterModal-module--registerText--475ff";
export var registerUserMessage = "UserRegisterModal-module--registerUserMessage--167d2";
export var registerUserMessageContainer = "UserRegisterModal-module--registerUserMessageContainer--9460d";
export var rotating = "UserRegisterModal-module--rotating--be832";
export var tacContainer = "UserRegisterModal-module--tacContainer--17667";
export var tacLink = "UserRegisterModal-module--tacLink--440de";
export var tacText = "UserRegisterModal-module--tacText--8a8c9";
export var title = "UserRegisterModal-module--title--8a8db";
export var titleWrapper = "UserRegisterModal-module--titleWrapper--fda38";
export var userRegisterModal = "UserRegisterModal-module--userRegisterModal--3b310";
export var visible = "UserRegisterModal-module--visible--2f41c";